import { UploadFileStyled } from './styles/UploadFileStyled'
import { File } from '../../../File'
import {
  type UploadFile as UploadFileInterface,
  UploadFileStatuses,
} from '../../types'
import { type UploadCommonProps } from '../../Upload'

export interface IUploadFileProps {
  innerProps: {
    file: UploadFileInterface
  }
  commonProps: UploadCommonProps
}

export const UploadFile = ({ innerProps }: IUploadFileProps) => {
  const { file } = innerProps

  return (
    <UploadFileStyled>
      <File
        data={{
          name: file.name,
          mimetype: file.mimetype,
          file: file.file,
          preview: file.preview,
          length: file.length,
          error:
            file.status === UploadFileStatuses.ERROR
              ? file.error || true
              : false,
        }}
        border={false}
      />
    </UploadFileStyled>
  )
}
